import { VIcon } from 'vuetify/lib/components/VIcon';
import ClickOutside from 'vuetify/lib/directives/click-outside';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          def: ClickOutside,
          name: "click-outside",
          rawName: "v-click-outside",
          value: _setup.closeDropdown,
          expression: "closeDropdown",
        },
      ],
      staticClass: "analyses-hero-search position-relative",
      attrs: { "data-qa": "analyses_hero_search" },
    },
    [
      _c(_setup.CoreSearchField, {
        attrs: {
          value: _setup.query,
          maxlength: "150",
          autocomplete: "off",
          placeholder: _setup.SEARCH_PLACEHOLDER,
          "clear-icon": "ui-icon-close-not-a-circle",
          "background-color": "bg-gray-0",
          readonly: _setup.isMobile,
          "data-qa": "analyses_hero_search_input",
          "debounce-ms": 300,
        },
        on: {
          input: _setup.onInput,
          "input:debounced": _setup.onDebouncedInput,
          focus: _setup.onFocus,
          click: _setup.onTriggerClick,
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _setup.goToFindPage.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      !_setup.isMobile && _setup.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass:
                "analyses-hero-search__dropdown bg-gray-0 rounded-sm",
              class: {
                "analyses-hero-search__dropdown_empty": _setup.isDropdownEmpty,
              },
              attrs: { "data-qa": "analyses_hero_search_dropdown" },
            },
            [
              _c(_setup.AnalysesHeroSearchResults, {
                attrs: {
                  query: _setup.query,
                  results: _setup.results,
                  "is-loading": _setup.isLoading,
                  "show-empty": !_setup.isLoading,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.isMobile
        ? _c(_setup.CoreDialog, {
            attrs: {
              size: "fullscreen",
              title: "Поиск анализа",
              divider: "",
              "data-qa": "analyses_hero_search_dialog",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "prependBtn",
                  fn: function () {
                    return [
                      _c(
                        VIcon,
                        {
                          staticClass: "cursor-pointer",
                          attrs: {
                            "data-qa": "analyses_hero_search_dialog_close",
                          },
                          on: { click: _setup.closeMobileDialog },
                        },
                        [_vm._v("\n        ui-icon-close-not-a-circle\n      ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "extension",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "mx-n2" },
                        [
                          _c(_setup.CoreSearchField, {
                            attrs: {
                              value: _setup.query,
                              maxlength: "150",
                              autocomplete: "off",
                              placeholder: _setup.SEARCH_PLACEHOLDER,
                              "clear-icon": "ui-icon-close-not-a-circle",
                              autofocus: "",
                              "data-qa": "analyses_hero_search_dialog_input",
                              "debounce-ms": 300,
                            },
                            on: {
                              input: _setup.onInput,
                              "input:debounced": _setup.onDebouncedInput,
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _setup.goToFindPage.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "default",
                  fn: function ({ counterXSpaceClass }) {
                    return [
                      _c(_setup.AnalysesHeroSearchResults, {
                        class: [counterXSpaceClass, "mt-n4"],
                        attrs: {
                          query: _setup.query,
                          results: _setup.results,
                          "is-loading": _setup.isLoading,
                          "show-empty":
                            _setup.isQueryReady && !_setup.isLoading,
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1004370782
            ),
            model: {
              value: _setup.isMobileDialogOpen,
              callback: function ($$v) {
                _setup.isMobileDialogOpen = $$v
              },
              expression: "isMobileDialogOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }